var App = App || {};

App.MarcRecordsCustom = (function ($) {

    const uploadUrl = '/CustomMarcRecordsController/CustomMarcRecords/SubmitCustomMarcRecordsRequest';

    const FAILURE_GENERATION = 'generation';

    return {
        init: init
    };

    function init() {
        const $section = $('.js-custom-marc-records');

        if (!$section.length) {
            return;
        }

        const $instSelect = $('#institution-select');

        const $file = $section.find('.js-custom-marc-records-file');
        const $submit = $section.find('.js-custom-marc-records-submit');
        const $defaultBlock = $section.find('.js-custom-marc-records-default');
        const $result = $section.find('.js-custom-marc-records-result');
        const $message = $section.find('.js-custom-marc-records-message');
        const $notFound = $section.find('.js-custom-marc-records-not-found');
        const $actions = $section.find('.js-custom-marc-records-actions');
        const $download = $section.find('.js-custom-marc-records-download');
        const $reset = $section.find('.js-custom-marc-records-reset');
        const $fileName = $message.find('.js-custom-marc-records-filename');

        const $messageParts = $message.children('span');

        function clearMessage() {
            $messageParts.addClass('hidden');
            $result.removeClass('custom-marc-records-result--error custom-marc-records-result--notice custom-marc-records-result--success');
            $notFound.addClass('hidden').empty();
        }

        function showMessage(partClass, appearance) {
            clearMessage();
            $result.addClass(appearance);
            $message.find(partClass).removeClass('hidden');
            $result.focus();
        }

        function listNotFound(notFound) {
            if (!notFound || !notFound.length) {
                return;
            }

            const fragment = document.createDocumentFragment();

            notFound.forEach(function (eisbn) {
                const item = document.createElement('li');
                item.textContent = eisbn;
                fragment.appendChild(item);
            });

            $notFound.append(fragment).removeClass('hidden');
        }

        function showDefaultBlock() {
            $defaultBlock.removeClass('hidden');
            $actions.addClass('hidden');
            $file.val('');
            $submit.prop('disabled', false);
        }

        function showResultActions(downloadUrl) {
            $defaultBlock.addClass('hidden');
            $actions.removeClass('hidden');
            $download.toggleClass('hidden', !downloadUrl);

            if (downloadUrl) {
                $download.attr('href', downloadUrl);
            }
        }

        function resetSection() {
            clearMessage();
            showDefaultBlock();
        }

        function handleFailure(partClass) {
            showMessage(partClass, 'custom-marc-records-result--error');
            showDefaultBlock();
        }

        function handleResponse(result) {
            $submit.prop('disabled', false);

            if (!result.Success) {
                const isGenerationFailure = result.Data && result.Data.FailureKind === FAILURE_GENERATION;

                handleFailure(isGenerationFailure
                    ? '.js-custom-marc-records-generation-error'
                    : '.js-custom-marc-records-file-error');
                return;
            }

            const data = result.Data || {};
            const notFound = data.NotFound || [];
            const downloadUrl = data.DownloadUrl || '';

            if (!downloadUrl) {
                showMessage('.js-custom-marc-records-none-found', 'custom-marc-records-result--error');
            } else if (notFound && notFound.length) {
                showMessage('.js-custom-marc-records-partial', 'custom-marc-records-result--error');
            } else {
                showMessage('.js-custom-marc-records-success', 'custom-marc-records-result--success');
            }

            listNotFound(notFound);
            showResultActions(downloadUrl);
        }

        function selectedInstitutionId() {
            if ($instSelect.length) {
                return $instSelect.val();
            }

            return $('.js-institution-wrap').first().data('institutionId');
        }

        $submit.on('click', function() {
            const chosenFile = $file.get(0).files[0];

            if (!chosenFile) {
                showMessage('.js-custom-marc-records-choose-file', 'custom-marc-records-result--error');
                return;
            }

            const payload = new FormData();
            payload.append('eisbnFile', chosenFile);
            payload.append('institutionId', selectedInstitutionId());
            payload.append('__RequestVerificationToken', $('input[name="__RequestVerificationToken"]').val());

            $fileName.text(chosenFile.name);
            showMessage('.js-custom-marc-records-processing', 'custom-marc-records-result--notice');

            $submit.prop('disabled', true);
            $download.removeAttr('href');

            SCM.Ajax.post(uploadUrl, payload)
                .expectActionResultModel()
                .then(handleResponse, function () {
                    handleFailure('.js-custom-marc-records-generation-error');
                });
        });

        $reset.on('click', function () {
            resetSection();
            $file.focus();
        });
    }

})(jQuery);

$(App.MarcRecordsCustom.init);
